export default __webpack_public_path__ + "static/media/headerReg.983ffd9f.png";